import { getGraphql } from '../static/graphql/getGraphql.js'

export const state = () => ({
  loading: [],
  availableOffers: [],
  familyOffers: [],
  declinedOffers: [],
  acceptedOffers: [],
  familyMembers: [],
  allOffers: [],
  complianceRequirementChecks: {},
})

export const mutations = {
  setLoading(state, payload) {
    state.loading.push(payload.key)

    // unique the array
    state.loading = [...new Set(state.loading)]

    // remove
    if (!payload.value) {
      state.loading = state.loading.filter((e) => e !== payload.key)
    }
  },
  setOfferUpdated(state, offerUpdated) {
    state.offerUpdated = offerUpdated
  },
  clearData(state) {
    state.loading = []
    state.availableOffers = []
    state.familyOffers = []
    state.declinedOffers = []
    state.acceptedOffers = []
    state.familyMembers = []
    state.allOffers = []
  },
  addFamilyOfferAndMember(state, payload) {
    const offer = payload.offer
    const family = payload.family

    const meta = JSON.parse(offer.campaignMeta)
    const parsedMeta = JSON.parse(meta)
    const parentOrgName = parsedMeta.parent_organization
      ? parsedMeta.parent_organization.name
      : 'Parent Organization'
    const perm =
      family.permissions && family.permissions.length ? family.permissions : ''
    const offerMeta = offer.meta ? JSON.parse(offer.meta) : ''
    const o = offerMeta ? JSON.parse(offerMeta) : ''
    const declinedBy = o.declined_by ? o.declined_by : ''
    const localization = parsedMeta.localization || false

    state.familyOffers.push({
      entity_uuid: family.entityUuid,
      offer_status: offer.offerStatusId,
      family_name: family.name,
      permission: perm,
      name: parsedMeta.name,
      type: parsedMeta.targeting_entity_type,
      amount: parsedMeta.payments.amount,
      partner_org: parentOrgName,
      declined_by: declinedBy,
      localization,
      description: parsedMeta.description,
      cadence: parsedMeta.payments.cadence,
      date_updated: offer.dateUpdated,
      total_payments: parsedMeta.payments.number,
      date_expires: offer.dateExpires,
      offer_entity_uuid: offer.offerUuid,
      recipient_entity_uuid: offer.memberEntityUuid,
      compliance_requirements: parsedMeta.compliance_requirements,
      campaign_entity_uuid: offer.campaignEntityUuid,
    })

    if (
      family.relationships.hasMember &&
      family.relationships.hasMember.length
    ) {
      state.familyMembers.push({
        family_entity: family.entityUuid,
        name: family.name,
        members: family.relationships.hasMember,
      })
    }
  },
  addVisibleOffer(state, payload) {
    const offer = payload.offer
    const meta = JSON.parse(offer.campaignMeta)
    const parsedMeta = JSON.parse(meta)
    const parentOrgName = parsedMeta.parent_organization
      ? parsedMeta.parent_organization.name
      : 'Parent Organization'
    const localization = parsedMeta.localization || false
    const offerToAdd = {
      name: parsedMeta.name,
      type: parsedMeta.targeting_entity_type,
      amount: parsedMeta.payments.amount,
      partner_org: parentOrgName,
      description: parsedMeta.description,
      campaign_meta: parsedMeta,
      localization,
      cadence: parsedMeta.payments.cadence,
      offer_status: offer.offerStatusId,
      date_updated: offer.dateUpdated,
      total_payments: parsedMeta.payments.number,
      date_expires: offer.dateExpires,
      offer_entity_uuid: offer.offerUuid,
      recipient_entity_uuid: offer.memberEntityUuid,
      compliance_requirements: parsedMeta.compliance_requirements,
      campaign_entity_uuid: offer.campaignEntityUuid,
    }

    state.allOffers.push(offerToAdd)
    if (offer.offerStatusId === 1) {
      state.availableOffers.push(offerToAdd)
    }
    if (offer.offerStatusId === 3) {
      state.declinedOffers.push(offerToAdd)
    }
    if (offer.offerStatusId === 2) {
      state.acceptedOffers.push(offerToAdd)
    }
  },
  setOfferComplianceRequirementCheck(state, payload) {
    state.complianceRequirementChecks[payload.campaignUuid] =
      payload.checkResponse
  },
}

export const actions = {
  async getOffers(context) {
    try {
      context.commit('clearData')
      const query = await getGraphql('my-offers.graphql')
      console.log('*** entered getOffers ***')
      context.commit('setLoading', { key: 'getOffers', value: true })

      const response = await this.$axios.$post('/GRAPHQL_URL/', {
        query,
      })

      // iterate through the list of offers and add it to the available offers list
      const offers =
        response.data.me.relationships.myself[0].campaignOffers.offersReceived
      if (offers && offers.length > 0) {
        for (let j = 0; j < offers.length; j++) {
          context.commit('addVisibleOffer', { offer: offers[j] })
        }
      }

      // iterate through the list of campaign offers received by the family and add it to the family offers list
      const families = response.data.me.relationships.memberOf
      if (families && families.length > 0) {
        for (let i = 0; i < families.length; i++) {
          if (
            families[i].entityType === 'family' &&
            families[i].campaignOffers &&
            families[i].campaignOffers.offersReceived.length
          ) {
            const offersReceived = families[i].campaignOffers.offersReceived
            for (let j = 0; j < offersReceived.length; j++) {
              context.commit('addFamilyOfferAndMember', {
                offer: offersReceived[j],
                family: families[i],
              })
            }
          }
        }
      }
    } catch (e) {
      console.log('Error getting available offers', e)
    } finally {
      context.commit('setLoading', { key: 'getOffers', value: false })
    }
    console.log('*** exiting getOffers ***')
  },
  async acceptOffer(context, args) {
    const offerUuid = args.offerUuid
    const offerStatus = args.offerStatus
    const relationshipPermission = args.relationshipPermission
    let result

    context.commit('setLoading', { key: 'acceptOffer', value: true })

    if (offerStatus.length && offerUuid.length) {
      const mutationQuery = await getGraphql('update-offer-status.graphql')

      const variables = {
        entityArgs: {
          offerStatus,
          offerUuid,
          relationshipPermission,
        },
      }
      try {
        const response = await this.$axios.$post('/GRAPHQL_URL/', {
          query: mutationQuery,
          variables,
        })
        result = response
        console.log(response)
      } catch (e) {
        console.log(e)
      } finally {
        context.commit('setLoading', { key: 'acceptOffer', value: false })
      }
    }
    return result
  },
  async offerComplianceCheck(context, args) {
    context.commit('setLoading', { key: 'offerComplianceCheck', value: true })

    let checkResponse

    // check if compliance requirements already checked
    if (
      context.state.complianceRequirementChecks[args.campaignUuid] !== undefined
    ) {
      checkResponse =
        context.state.complianceRequirementChecks[args.campaignUuid]
    }

    // else, fire ad-hoc check
    else {
      const payload = {
        campaign_uuid: args.campaignUuid,
      }
      if (args.purpose) {
        // optional variable
        payload.purpose = args.purpose
      }
      try {
        const response = await this.$axios.$post(
          '/CORE_URL/campaigns/compliance/check/single',
          payload
        )
        console.log(response)
        // parse results
        checkResponse = response || {}

        // save to state
        context.commit('setOfferComplianceRequirementCheck', {
          campaignUuid: args.campaignUuid,
          checkResponse,
        })
      } catch (e) {
        console.log(e)
      }
    }

    // TODO: setup more error handling

    context.commit('setLoading', { key: 'offerComplianceCheck', value: false })

    return checkResponse?.all_compliant || {}
  },
  async declineOffer(context, args) {
    const offerUuid = args.offerUuid
    const offerStatus = args.offerStatus
    const declineReason = args.declineReason
    const relationshipPermission = args.relationshipPermission
    let result

    context.commit('setLoading', { key: 'declineOffer', value: true })

    if (offerStatus.length && offerUuid.length) {
      const mutationQuery = await getGraphql('update-offer-status.graphql')

      const variables = {
        entityArgs: {
          offerStatus,
          offerUuid,
          declineReason,
          relationshipPermission,
        },
      }
      try {
        const response = await this.$axios.$post('/GRAPHQL_URL/', {
          query: mutationQuery,
          variables,
        })

        console.log(response)
        result = response
      } catch (e) {
        console.log(e)
      } finally {
        context.commit('setLoading', { key: 'declineOffer', value: false })
      }
    }
    return result
  },
}

export const getters = {}
